import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/core/services/app.service';
import { ToastrService } from 'ngx-toastr';
import {AppConfigService} from "../../../core/services/config.service";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  submitted = false;
  matricule: string;
  token: string;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private _service: AppService,
    public configService: AppConfigService,
    private toastrService: ToastrService
  ) { }

  ngOnInit() {
    this.resetPasswordForm = this.formBuilder.group({
      password: ['', [Validators.required]],
      confirm_password: ['', Validators.required]
    }, {
      validator: this.passwordMatchValidator
    });

    // Retrieve the query parameters from the URL
    this.route.queryParams.subscribe(params => {
      this.matricule = params['matricule'];
      this.token = params['token'];
    });
  }

  getLogoPath(): string {
    const client = this.configService.get('SIGLE');
    if (client === 'SIR') {
      return 'assets/img/logo_SIR_transparent.png';
    } else if (client === 'SMB') {
      return 'assets/img/SMB/logo-icon.png';
    }
  }

  get f() { return this.resetPasswordForm.controls; }

  passwordMatchValidator(formGroup: FormGroup) {
    const password = formGroup.get('password').value;
    const confirmPassword = formGroup.get('confirm_password').value;

    if (password !== confirmPassword) {
      formGroup.get('confirm_password').setErrors({ passwordMismatch: true });
    } else {
      formGroup.get('confirm_password').setErrors(null);
    }
  }

  onSubmit() {
    this.submitted = true;

    if (this.resetPasswordForm.invalid) {
      return;
    }

    const resetData = {
      matricule: this.matricule,
      password: this.f.password.value,
      confirm_password: this.f.confirm_password.value,
      token: this.token
    };

    this._service.postData('reset-password', resetData)
      .subscribe(
        (res: any) => {
          this.toastrService.success(res.message || 'Mot de passe réinitialisé avec succès');
          // Nettoyer le localStorage après une réinitialisation réussie
          localStorage.removeItem('resetPasswordToken');
          localStorage.removeItem('resetPasswordMatricule');
          // Rediriger vers la page de connexion
          this.router.navigate(['/login']);
        },
        (err: any) => {
          this.toastrService.error(err.error?.message || 'Une erreur est survenue lors de la réinitialisation du mot de passe');
        }
      );
  }

}
